import { render, staticRenderFns } from "./ManufacturingInfoCard.vue?vue&type=template&id=845cf528&"
import script from "./ManufacturingInfoCard.vue?vue&type=script&lang=js&"
export * from "./ManufacturingInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports